/*
    © 2021 EcomGraduates
*/

// Quantity change
window.initCartQty = () => {
let onGift = localStorage.getItem('gifOn') === 'true' ? true : false;
let LimitGift = Number(localStorage.getItem('gifLimit'));
let productId = Number(localStorage.getItem('gifProduct'));
let productPrice = Number(localStorage.getItem('gifPrice')) / 100;
let totalPrice = 0;
let key = 0;
let isProduct = true;

function replaceInfo(newDocument) {
    if(totalPrice != 0) {
        //replace cart drawer
        document.querySelector('#offcanvas-cart-inner .offcanvas-body')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner .offcanvas-body'))
        document.querySelector('#offcanvas-cart-inner #cart-subtotal-value')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner #cart-subtotal-value'))
        document.querySelector('#offcanvas-cart-inner #offcanvas-footer')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner #offcanvas-footer'))
        //replace cart page
        document.querySelector('#cart-page .cart-product-list')?.replaceWith(newDocument.querySelector('#cart-page .cart-product-list'))
        document.querySelector('#cart-page #cart-subtotal')?.replaceWith(newDocument.querySelector('#cart-page #cart-subtotal'))
    } else {
        //replace cart page
        document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
        //replace cart drawer
        document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
    }
}

function addItem() {
    // Definition of URL for adding a product to the cart
    const addToCartUrl = `/cart/add.js?id=${productId}`;

    // Send request to add product to cart
    fetch(addToCartUrl)
    .then(response => {
        if (response.ok) {
        document.body.classList.add('free-modal');
        }
    })
    .then(()=> {
        fetch(window.location.href)
        .then((response) => response.text())
        .then((data2) => {
            const parser = new DOMParser()
            const newDocument = parser.parseFromString(data2, 'text/html')
            replaceInfo(newDocument);
            if (totalPrice === 0) {
                setTimeout(() => {
                    const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                    offcanvas.hide()
                }, 500)
            }
            window.initCartQty()
            window.initHandleRemoveButtons()
            window.initCartTimer()
        })
    })
    .catch(error => {
        console.error("An error occurred while executing the query:", error);
    });
}

// Quantity change
window.initCartQty = () => {

    document.querySelectorAll('#btn-checkout').forEach((el) => {
        el.classList.add('disabled');
    });
    
    
    fetch("/cart.json")
    .then(response => {
        if (response.ok) {
        return response.json();
        } else {
        throw new Error("An error occurred while retrieving cart information.");
        }
    })
    .then(cartData => {

        if(onGift) {
            const foundProduct = cartData.items.find(product => product.variant_id === productId);

        if (foundProduct) {
            key = foundProduct.key;
            isProduct = false;
            totalPrice = Number(cartData.total_price / 100) - productPrice;
        } else {
            isProduct = true;
            totalPrice = Number(cartData.total_price / 100);
        }


        if(totalPrice >= LimitGift && isProduct) {
            addItem();
        } else if((totalPrice <= LimitGift && !isProduct) || (cartData.items.length == 1 && !isProduct)) {
            // Sending a request to remove an item from the cart
            console.log('remove');
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: key,
                    quantity: 0
                })
            })
            .then(()=> {
                fetch(window.location.href)
                .then((response) => response.text())
                .then((data2) => {
                    const parser = new DOMParser()
                    const newDocument = parser.parseFromString(data2, 'text/html')
                    replaceInfo(newDocument);
                    if (totalPrice === 0) {
                        setTimeout(() => {
                            const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                            offcanvas.hide()
                        }, 500)
                    }
                    window.initCartQty()
                    window.initHandleRemoveButtons()
                    window.initCartTimer()
                })
            })
        }
        }
        
    })

    setTimeout(()=> {
        document.querySelectorAll('#btn-checkout').forEach((el) => {
            el.classList.remove('disabled');
        });
    }, 1000);
    

    document.querySelectorAll('.cart-qty').forEach((el) => {

        var currentValue = el.value;
        var newValue;

        if (!el.classList.contains('init')) {
            el.classList.add('init')
            el.addEventListener('change', () => {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: el.dataset.lineItemKey,
                        quantity: el.value
                    })
                })
                    .then((response) => response.json())
                    .then((data) => {

                        newValue = el.value;

                        if(currentValue > newValue) {
                            var diffValue = currentValue - newValue;
                            var eventName = 'remove_from_cart';
                        } else {
                            var diffValue = newValue - currentValue;
                            var eventName = 'ee_addToCart';
                        }

                        currentValue = newValue;

                        window.dataLayer.push({
                            event: eventName,
                            name: el.getAttribute('data-name'),
                            id: el.getAttribute('data-id'),
                            price: (el.getAttribute('data-price') / 100).toFixed(2).toString(),
                            currency: el.getAttribute('data-currency').toString(),
                            brand: el.getAttribute('data-brand'),
                            quantity: diffValue,
                            g_product_id: "shopify_US_"+el.getAttribute('data-id')+"_"+el.getAttribute('data-variantid')
                        });

                        console.log(data)

                        let onlyShippingProtectionInCart = data.item_count === 1 && data.items[0].handle === 'ppcom-package-protection';

                        if (data.item_count == 0 || onlyShippingProtectionInCart) {
                          document.querySelector('#btn-checkout').classList.add('disabled');
                          document.querySelector('#cart-indicator').style.display = 'none';
                        }
                        
                        document.querySelectorAll('.cart-items-count').forEach((el2) => {
                            el2.textContent = data.item_count
                        })

                        fetch(window.location.href)
                            .then((response) => response.text())
                            .then((data2) => {
                                const parser = new DOMParser()
                                const newDocument = parser.parseFromString(data2, 'text/html')
                                document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                                document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
                                if (data.items.length === 0) {
                                    setTimeout(() => {
                                        const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                                        offcanvas.hide()
                                    }, 500)
                                }
                                // Trigger GWP check after cart quantity change
                                document.dispatchEvent(new CustomEvent('cart:build'));
                                window.initCartQty()
                                window.initHandleRemoveButtons()
                                window.initCartTimer()
                            })
                    })
            })
        }
    })
}
window.initCartQty()

// Handle remove button
window.initHandleRemoveButtons = () => {
    document.querySelectorAll('.offcanvas-cart-remove-btn').forEach((btn) => {
        if (!btn.classList.contains('init')) {
            btn.classList.add('init')
            btn.addEventListener('click', (e) => {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: btn.dataset.lineItemKey,
                        quantity: 0
                    })
                })
                    .then((response) => response.json())
                    .then((data) => {
                        console.log(data)

                        document.querySelectorAll('.cart-items-count').forEach((el2) => {
                            el2.textContent = data.item_count
                        })

                        fetch(window.location.href)
                            .then((response) => response.text())
                            .then((data2) => {
                                const parser = new DOMParser()
                                const newDocument = parser.parseFromString(data2, 'text/html')
                                document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                                document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
                                if (data.items.length === 0) {
                                    setTimeout(() => {
                                        const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                                        offcanvas.hide()
                                    }, 500)
                                }
                                // Trigger GWP check after item removal
                                document.dispatchEvent(new CustomEvent('cart:build'));
                                window.initCartQty()
                                window.initHandleRemoveButtons()
                                window.initCartTimer()
                            })
                    })
            })
        }
    })
}
window.initHandleRemoveButtons();

// Summary sticky top layout
(() => {
    const cartSummary = document.querySelector('#cart-summary.sticky-top')
    if (cartSummary) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight
        cartSummary.style.top = navbarHeight + 20 + 'px'
        cartSummary.style.zIndex = '1019'
    }
})()

// Footer Upsell (PackageProtection)
const initFooterUpsell = async () => {
    const checkbox = document.querySelector('#cart-footer-upsell-checkbox')

    const isAlreadyInCart = async () => {
        const response = await fetch('/cart.json')
        const data = await response.json()

        data.items.forEach((item) => {
            console.log(item.id)
        })

        return data.items.some(item => item.id === 41523213664425)
    }

    if (checkbox) {
        checkbox.addEventListener('change', async () => {
            if (checkbox.checked) {
                const isInCart = await isAlreadyInCart()

                if (!isInCart) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: checkbox.dataset.variantId,
                            quantity: 1
                        })
                    })
                }
            } else {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: checkbox.dataset.variantId,
                        quantity: 0
                    })
                })
            }
            const respoonse = await fetch(window.location.href)
            const data = await respoonse.text()

            const parser = new DOMParser()
            const newDocument = parser.parseFromString(data, 'text/html')

            document.querySelector('#cart-subtotal-value').replaceWith(newDocument.querySelector('#cart-subtotal-value'))
        })

        setTimeout(async () => {
            const userHasSelectedBefore = localStorage.getItem('package_protection_user_has_selected')
            if (!userHasSelectedBefore) {
                const isInCart = await isAlreadyInCart()

                console.log(isInCart)

                if (!isInCart) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: checkbox.dataset.variantId,
                            quantity: 1
                        })
                    })
                    localStorage.setItem('package_protection_user_has_selected', true)

                    checkbox.checked = true

                    const respoonse = await fetch(window.location.href)
                    const data = await respoonse.text()

                    const parser = new DOMParser()
                    const newDocument = parser.parseFromString(data, 'text/html')

                    document.querySelector('#cart-subtotal-value').replaceWith(newDocument.querySelector('#cart-subtotal-value'))
                }
            }
        }, 1000)
    }
}
initFooterUpsell()

// Cart Timer
window.initCartTimer = async () => {
    const wrapper = document.querySelector('#cart-timer')

    if (!wrapper) {
        return
    }

    if (!localStorage.getItem('eg-cart-timer')) {
        return
    }

    const end = Number(localStorage.getItem('eg-cart-timer'))

    if (end < new Date().getTime()) {
        localStorage.removeItem('eg-cart-timer')

        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })

        return
    }

    wrapper.querySelector('#cart-timer-inner').innerHTML = wrapper.dataset.text
    wrapper.style.display = 'block'

    const seconds = 1000
    const minutes = seconds * 60
    const hours = minutes * 60

    let addedMinutes = ''
    let addedSeconds = ''

    const x = setInterval(() => {
        const now = new Date().getTime()
        const difference = end - now

        if (difference < 0) {
            clearInterval(x)
            localStorage.removeItem('eg-cart-timer')
            wrapper.style.display = 'none'
            return
        }

        addedMinutes = Math.floor((difference % hours) / minutes)

        if (addedMinutes < 10) {
            addedMinutes = `0${addedMinutes}`
        }

        addedSeconds = Math.floor((difference % minutes) / seconds)

        if (addedSeconds < 10) {
            addedSeconds = `0${addedSeconds}`
        }

        wrapper.querySelector('[data-minutes').innerText = addedMinutes
        wrapper.querySelector('[data-seconds').innerText = addedSeconds
    }, seconds)
}
window.initCartTimer()

window.setCartTimer = () => {
    const wrapper = document.querySelector('#cart-timer')

    if (!wrapper) {
        return
    }

    const end = new Date().getTime() + Number(wrapper.dataset.minutes) * 60000

    localStorage.setItem('eg-cart-timer', end)

    window.initCartTimer()
}

}